export default __webpack_public_path__ + "static/media/hexometer-logo-rectangle.0c2e896d.svg";